export const getUrlFragment = (location, part) => location.pathname.split('/')[part];
 export const getUrlLastFragment = (location) => {
   const urlFragments = location.pathname.split('/');

   return urlFragments[urlFragments.length - 1]
 }
